import { render } from "./ResetControlNumber.vue?vue&type=template&id=2728be3e"
import script from "./ResetControlNumber.vue?vue&type=script&lang=js"
export * from "./ResetControlNumber.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__